import React, { useEffect, useState } from 'react'
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';
import "./MyOrders.css";

export default function MyOrder() {

    const [orderData, setOrderData] = useState([])

    const fetchMyOrder = async () => {
        await fetch("https://hungryhub-backend.vercel.app/api/myorders", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                email: localStorage.getItem('userEmail')
            })
        }).then(async (res) => {
            let response = await res.json()
            await setOrderData(response)
        }).catch((error) => {
            console.log(error.message);
        })
    }

    useEffect(() => {
        fetchMyOrder()
    }, [])
    return (
        <div>
            <Navbar />
            <div className='order-history'>
                {
                    orderData.length === 0 ? <p className='no-history'>No History</p> :
                        orderData.map((order, index) => (
                            <div key={index} className="order">
                                <h3>Order Date: {order[0].OrderDate}</h3>
                                <ul>
                                    {order.slice(1).map((item, itemIndex) => (
                                        <li key={itemIndex} className="order-item">
                                            <img src={item.img} alt={item.name} />
                                            <div className="order-details">
                                                <h4>{item.name}</h4>
                                                <p>Price: ₹{item.price}</p>
                                                <p>Quantity: {item.quantity}</p>
                                                <p>Size: {item.size}</p>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))
                }
            </div>
            <Footer />
        </div>
    )
}